var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageTemplatePlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#858891",
  d: "M30.834 24.657V12.5c0-.415-.138-.745-.43-1.037a1.39 1.39 0 0 0-1.037-.43H10.62a1.4 1.4 0 0 0-1.015.42l-.008.01c-.293.292-.43.622-.43 1.037v17.155l3.476-3.477h16.724v.834H12.988l-4.654 4.655V12.5q0-.953.673-1.626a2.22 2.22 0 0 1 1.4-.666l.226-.008h18.734q.953 0 1.626.674.674.673.674 1.626v12.157l-.01.234a2.3 2.3 0 0 1-.664 1.42q-.588.612-1.392.69l-.234.01v-.833c.404 0 .73-.137 1.025-.444a1.48 1.48 0 0 0 .442-1.077"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#858891",
  d: "M13.334 21.667h13.333v.833H13.334zM13.334 18.334h13.333v.833H13.334zM13.334 15h13.333v.834H13.334z"
})));
export default SvgMessageTemplatePlaceholder;